import { Card, Grid, Skeleton } from "@mantine/core";

export default function JobCardSkeleton({ ...props }) {
  return (
    <Card padding="lg" withBorder {...props} style={{ borderRadius: "12px" }}>
      <Grid gutter={0} align="center">
        <Grid.Col span={4}>
          <div className="flex items-center">
            <Skeleton height={60} circle />
            <div className="ms-4">
              <Skeleton height={24} mb={8} width={130} radius="xl" />
              <Skeleton height={17} mt={8} width={150} radius="xl" />
            </div>
          </div>
        </Grid.Col>
        <Grid.Col span={4}>
          <div className=" ps-[30px]">
            <div className="flex flex-wrap">
              <Skeleton height={24} width={80} radius="sm" mt={4} mx={4} />
              <Skeleton height={24} width={80} radius="sm" mt={4} mx={4} />
            </div>
            <div className="flex flex-wrap mt-2">
              <div className="flex items-center text-primary">
                <Skeleton height={18} mt={0} mx={4} width={100} radius="xl" />
              </div>
              <div className="flex items-center text-primary">
                <Skeleton height={18} mt={0} mx={4} width={100} radius="xl" />
              </div>
            </div>
          </div>
        </Grid.Col>
        <Grid.Col span={2} className="flex flex-col justify-center">
          <div className="flex flex-wrap items-center">
            <Skeleton height={18} mt={0} mx={4} width={100} radius="xl" />
          </div>
          <div className="flex flex-wrap mt-2  items-center">
            <Skeleton height={18} mt={0} mx={4} width={100} radius="xl" />
          </div>
        </Grid.Col>
        <Grid.Col span={2} className="flex items-center lg:justify-end">
          <Skeleton height={36} width={36} className="me-2" radius="md" />
          <Skeleton height={36} width={60} radius="md" />
        </Grid.Col>
      </Grid>
    </Card>
  );
}
